<template>
  <div class="as-work-order-wrap">
    <el-table
      max-height="600"
      :data="tableData"
      v-loading="loading"
      style="width: 100%"
      @filter-change="filterChange"
    >
      <el-table-column
        prop="exceptionOrderNo"
        label="工单号"
        width="180"
        v-if="type === 'asOrder'"
      />
      <el-table-column
        prop="businessKey"
        label="子订单号"
        width="180"
        v-if="type === 'order'"
      />
      <el-table-column
        prop="exceptionOrderNo"
        label="关联工单"
        width="180"
        v-if="type === 'order'"
      />
      <el-table-column prop="workOrderTypeDesc" label="工单类型" />
      <el-table-column
        prop="statusDesc"
        label="工单状态"
        column-key="statusDesc"
        filterable
        :filters="[
          { text: '新建', value: 1 },
          { text: '开始处理', value: 2 },
          { text: '已处理', value: 3 },
          { text: '驳回处理', value: 4 },
          { text: '完成', value: 99 },
          { text: '关闭', value: 0 }
        ]"
      >
      </el-table-column>
      <el-table-column prop="createdByName" label="创建人"> </el-table-column>
      <el-table-column prop="operatorName" label="受理人">
        <template slot-scope="scope">
          <span v-if="scope.row.targetSystem == 1">客服</span>
          <span v-else-if="scope.row.targetSystem == 5">{{ userName }}</span
          ><span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="rejectOrder"
            @click="getDetail(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="size"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :pager-count="11"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElements"
      v-if="totalElements"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  getWorkOrderList //关联工单列表
} from "@/models/aftersaleModel";

export default {
  name: "asWorkOrder",
  props: ["as_number", "type", "randomNum"],
  data() {
    return {
      tableData: [],
      page: 1,
      size: 10,
      totalElements: 0,
      loading: false,
      userName: localStorage.getItem("username")
    };
  },
  watch: {
    randomNum() {
      console.log("222--", this.as_number);
      this.tableData = [];
      this.getList({ businessNumberList: this.as_number }, 0, 10);
    }
  },
  created() {
    if (this.as_number) {
      this.getList({ businessNumberList: this.as_number }, 0, 10);
    }
  },
  methods: {
    // 获取关联工单号
    async getList(obj, page, size) {
      const params = {
        ...obj,
        page: page || 0,
        size: size || 10,
        supplierId: localStorage.getItem("supplier_id"),
        relationSystem: 5
        // currentSystem: 5 //R4店铺-5
      };
      try {
        const res = await getWorkOrderList(params);
        console.log("res-----", res);
        this.tableData = res.content || [];
        this.page = res.page + 1;
        this.size = res.size;
        this.totalElements = res.total;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 每页条数
    handleSizeChange(val) {
      this.loading = true;
      this.size = val;
      this.page = 1;
      // this.piceWorkOrder(this.as_number, 0, val);
      this.getList({ businessNumberList: this.as_number }, 0, val);
    },
    // 页码改变
    handleCurrentChange(val) {
      this.loading = true;
      this.page = val;
      // this.piceWorkOrder(this.as_number, val - 1, this.size);
      this.getList({ businessNumberList: this.as_number }, val - 1, this.size);
    },
    // 工单详情-跳转
    async getDetail(scope) {
      this.$router.push({
        path: "/orderList/detail",
        query: {
          exceptionOrderNo: scope.exceptionOrderNo,
          activeColor:
            scope.targetSystem == 1
              ? 1
              : scope.targetSystem == 5
              ? 2
              : undefined //1-我创建的，5-我受理的(转成2，提供给工单详情用)
        }
      });
    },

    filterChange(column) {
      // console.log("filter--:", column);
      const status = column.statusDesc;
      this.getList({ businessNumberList: this.as_number, status }, 0, 10);
    }
  }
};
</script>
<style lang="scss" scoped>
.as-work-order-wrap {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/aftersale/work-order.vue